import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { UserService } from './user.service';
import * as _ from "lodash";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LogicoyService {
  tenantZipCode: any;
  tenantState: any;
  tenantCity: any;
  tenantStreet: any;
  DEA: any;
  pharmacyName: any;
  constructor(private _commonSer: CommonService, private _userService: UserService) { }

  PMPNow(rxFG) {
    this._commonSer.getLogiCoyPDMPReport().subscribe(resp => {
      if (resp) {
          let DataToPost = this.logicoy(rxFG,resp,null,false);
          this._commonSer.getLogicoyUrl(resp['UserName'],resp['Password'],resp['InterfaceURL'],DataToPost).subscribe(res => {
              if (res) {
                  let logicoyLink = res['Report']?.['ReportRequestURLs']?.['ViewableReport']?.Value
                  window.open(logicoyLink, "_blank");
              }
          });
      }
  });
  }
  newPDMPNow(rxFG: any, vendorId?: any): Observable<any> {
    const appuserId = this._commonSer.DecryptData(localStorage.getItem("UserId"));
    return this._commonSer.getLogedInUserDetails(appuserId).pipe(
      map((userResp: any) => {
        this._commonSer.storeLoggedInUserDetails(userResp);
        if (userResp) {
          return this.logicoy(rxFG, userResp, vendorId, true);
        } else {
          return null;
        }
      })
    );
  }

  logicoy(patient,logicoyResp, vendorId?,fromNewPdmp?:boolean) {
    let result;
    this._commonSer._newTenatInfo$.subscribe(resp => {
      if (resp && resp["PharmacyDetails"]) {
          this.tenantZipCode = resp["PharmacyDetails"]["ZipCode"];
          this.tenantState = resp["PharmacyDetails"]["StateName"];
          this.tenantCity = resp["PharmacyDetails"]["CityName"],
          this.tenantStreet = resp["PharmacyDetails"]["AddressLine1"],
          this.DEA = resp["PharmacyDetails"]["DEARegistration"],
          this.pharmacyName = resp["PharmacyDetails"]["PharmacyName"];
      }
    });

   if(fromNewPdmp){
       result = {
          PharmacistDetails: {
          FirstName: logicoyResp["FirstName"],
          LastName: logicoyResp["LastName"],
          DEANumber: logicoyResp["DEANum"],
          NPINumber: logicoyResp["NPINum"],
          Role: vendorId === "Bamboo" ? 'Pharmacist' : this._userService.getToken("TechUserName") ? 'TECHNICIAN' : 'ADMIN',
          ApprisLicenseNumber: logicoyResp["StateLicense"],
          ApprisLicenseState: this.tenantState,
          ApprisLicenseType: "Pharmacist"
        },
        PharmacyLocation: {
          Name: vendorId === "Bamboo" ? this.pharmacyName : "RVC",
          DEANumber: this.DEA,
          NPINumber: this._commonSer.DecryptData(localStorage.getItem("UniquePharmacyId")),
          NCPDPNumber: null,
          Street: this.tenantStreet,
          City: this.tenantCity,
          State: this.tenantState,
          ZipCode: this.tenantZipCode
        },
        Patient: {
          FirstName: patient.firstname,
          LastName: patient.lastname,
          DateOfBirth: vendorId === "Bamboo" ? moment(patient?.dob, "MM/DD/YYYY").format("YYYY-MM-DD") : patient.dob,
          Gender : patient.gender,
          Phone: patient.mobile,
          SSNum : patient.PatientInfo ? patient.PatientInfo.SSNum : null,
          State: patient.state,
          City: patient.city,
          zipCode: patient.zipcode,
          Street: patient.address1
        }
      }
   } else {
    result = {
      Requester: {
        LicenseeRequestIdField: logicoyResp['LicenseeRequestId'],
        Location: {
            Address: {
                City: this.tenantCity,
                StateCode: this.tenantState,
                Street: [this.tenantStreet],
                ZipCode: this.tenantZipCode
            },
            DEANumber: this.DEA,
            Name: logicoyResp['PharmacyName'],
            npi: this._commonSer.DecryptData(localStorage.getItem("UniquePharmacyId"))
        },
        Provider: {
            DEANumber: this.DEA,
            FirstName: logicoyResp["providerFirstName"],
            LastName: logicoyResp["providerLastName"],
            NPINumber: this._commonSer.DecryptData(localStorage.getItem("UniquePharmacyId")),
            ProfessionalLicenseNumber: null,
            Role: vendorId === "Bamboo" ? 'Pharmacist' : this._userService.getToken("TechUserName") ? 'TECHNICIAN' : 'ADMIN'
        }
      },
      PrescriptionRequest: {
          Patient: {
              Address: {
                  City: patient.city,
                  StateCode: patient.state,
                  Street: [patient.address1],
                  ZipCode: patient.zipcode
              },
              Birthdate: vendorId === "Bamboo" ? moment(patient?.dob, "MM/DD/YYYY").format("YYYY-MM-DD") : patient.dob,
              Name: {
                  First: patient.firstname,
                  Last: patient.lastname
              },
              Phone: patient.mobile,
              SexCode: vendorId === "Bamboo" ? (patient.gender === "Male" ? "M" : patient.gender === "Female" ? "F" : "U") : patient.gender
          }
      },
    }
   }
  return result;
  }
}
